<template>
  <div class="xiaji">
     <el-table
       :data="list"
       style="width: 100%;margin-top:10px;" v-loading="loading">
       <el-table-column
          prop="phone"
          label="手机号" align="center">
        </el-table-column>
        <el-table-column
           prop="create_time"
           label="注册时间" align="center">
         </el-table-column>
         <el-table-column
            label="当前身份" align="center">
            <template slot-scope="scope">
              {{
                scope.row.role==1?"临时会员":scope.row.role==2?"VIP会员":scope.row.role==3?"代理":"--"
              }}
            </template>
          </el-table-column>
    </el-table>
    <div style="width: 100%;margin-top: 20px;display: flex;align-items: center;justify-content: flex-end;">
      <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[20]"
            :page-size="limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex"
  import { getXiajiList } from "@/api/gw/user"
  export default {
    computed:{
      ...mapGetters(["userinfo"]),
    },
    data(){
      return{
         loading:false,
         list:[],
         total:0,
         page:1,
         limit:20
      }
    },
    mounted(){
       this.$store.dispatch("getUserInfo");
       this.getList();
    },
    methods:{
      getList(){
        this.loading = true
        getXiajiList({
          page:this.page,
          limit:this.limit
        }).then(res=>{
          console.log("代理列表",res.data);
          this.total = res.data.total
          this.list = res.data.data
        }).finally(()=>{
          this.loading = false
        })
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.limit = val
        this.getList()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.page = val
        this.getList()
      },
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/home/components/xiaji.vue